// extracted by mini-css-extract-plugin
module.exports = {"PartnerProfile":"PartnerProfile_PartnerProfile__35Ij1","PartnerPhoto":"PartnerProfile_PartnerPhoto__1YlPJ","PartnerDesc":"PartnerProfile_PartnerDesc__3GEhE"};